/**
 * 環境識別リボン
 * 本番環境以外で画面左上にリボンを表示する
 */
export const EnvironmentRibbon = () => {
    const env = import.meta.env.VITE_APP_ENV;

    // 本番環境では表示しない
    if (env === 'production') {
        return null;
    }

    const isLocal = env === 'local';
    const backgroundColor = isLocal ? '#55423d' : '#140d0b';
    const ribbonText = isLocal ? 'LOCAL' : 'DEVELOP';

    return (
        <>
            <style>{`
                .github-fork-ribbon:before { background-color: ${backgroundColor}; }
                .github-fork-ribbon.left-top.fixed {
                    position: fixed;
                    top: 0;
                    left: 0;
                    z-index: 99999;
                }
                .github-fork-ribbon {
                    width: 12.1em;
                    height: 12.1em;
                    position: absolute;
                    overflow: hidden;
                    top: 0;
                    left: 0;
                    z-index: 99999;
                    pointer-events: none;
                    text-decoration: none;
                    text-indent: -999999px;
                }
                .github-fork-ribbon:before, .github-fork-ribbon:after {
                    position: absolute;
                    display: block;
                    width: 15.38em;
                    height: 1.54em;
                    top: 3.23em;
                    left: -3.23em;
                    transform: rotate(-45deg);
                    box-sizing: content-box;
                }
                .github-fork-ribbon:before {
                    content: "";
                    padding: .38em 0;
                    background-color: #333;
                    box-shadow: 0 .15em .23em 0 rgba(0,0,0,.5);
                    pointer-events: auto;
                }
                .github-fork-ribbon:after {
                    content: attr(data-ribbon);
                    color: #fff;
                    font: 700 1em sans-serif;
                    line-height: 1.54em;
                    text-decoration: none;
                    text-align: center;
                    text-indent: 0;
                    padding: .15em 0;
                    border-width: .08em 0;
                    border-style: dotted;
                    border-color: rgba(255,255,255,.7);
                }
            `}</style>
            <a
                className="github-fork-ribbon left-top fixed"
                data-ribbon={ribbonText}
            >
                {ribbonText}
            </a>
        </>
    );
};